module.exports = __webpack_public_path__ + "static/media/coin.48f1404f.png";